// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e94d9465","453":"ebb10860","455":"cfd31b56"}[chunkId] + ".chunk.js";
};